<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="active" background-color="#ffffff" mode="horizontal"
            text-color="#575757" active-text-color="#ff8800" router @select="handleSelect">
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <span slot="title" class="menutitle">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title" class="menutitle">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index"
                                    class="menutitle">
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index" class="menutitle">
                                {{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <span slot="title" class="menutitle">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import bus from '../common/bus';
export default {
    data() {
        return {
            collapse: false,
            active:'home',
            items: [
                {
                    index: 'home',
                    title: '网站首页'
                },
                {
                    index: 'games',
                    title: '全部游戏'
                },
                {
                    index: '3',
                    title: '账号交易',
                    subs: [
                        {
                            index: 'games',
                            title: '我要买号'
                        },
                        {
                            index: 'help',
                            title: '我要卖号'
                        }
                    ]
                },
                {
                    index: 'guide',
                    title: '交易指南'
                },
                {
                    index: 'help',
                    title: '帮助中心'
                },
                {
                    index: 'about',
                    title: '关于我们'
                }
            ]
        }
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
        })
    },
    watch: {
        // 监听路由对象中的params或query的变化
        '$route': {
            handler: function (to, from) {
               
                let path=this.$route.path.replace('/','');
                if(path=='selectgame')this.active='games';
                else this.active=path;
            },
            // 设置为true则表示立即监听，不需要等到下一次DOM更新循环
            immediate: true
        }
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);

        }
    }
}
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    top: 160px;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 0px 0px #d7d7d7;

}

.sidebar::-webkit-scrollbar {
    width: 0;

}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 1200px;
    left: calc(50% - 600px);
}

.sidebar>ul {
    height: 60px;
}



.el-menu-item {
    width: 200px;
    height: 60px;
    text-align: center;
  
  
}

.el-submenu {
    width: 200px;
    height: 60px;
    text-align: center;
}

.menutitle {
    font-size: 20px;
    text-align: center;
    width: 100% !important;
    height: 60px !important;
    line-height: 60px !important;
    font-size: 18px !important;
}



.el-menu-item.is-active {
    border-bottom: 3px solid #ff8800;
    background-color: #ff8800 !important;
    color: #ffffff !important;

}



.menutitle.is-active {
    border-bottom: 3px solid #ff8800;
    background-color: #ff8800 !important;
    color: #ffffff !important;

}
</style>
